import { useLocalizedVariant, useCountry, useSettings } from '@backpackjs/storefront';
import { getDiscountedPrice } from '@/utils/Helper';
import { getMetafieldMap } from '@/utils/Metafields';

function ProductPrice({
  product,
  variant,
  selectedPlan,
  planPrice,
  comparePriceText = '',
  className = '',
  compareStyles = '',
}) {
  const settings = useSettings();
  const { country } = useCountry();
  const { localized: localizedVariant } = useLocalizedVariant({ variant });
  const selectedVariant = { ...variant, ...localizedVariant };
  const isLocalized = !!selectedVariant?.priceV2?.locale;
  const currencySymbol = isLocalized ? country?.currency?.symbol || '$' : '$';

  const getCompareAtPrice = () => {
    let comparePrice;

    if (selectedVariant?.compareAtPriceV2?.amount) {
      comparePrice = parseFloat(
        selectedVariant?.compareAtPriceV2?.amount
      ).toFixed(2);
    }

    if (selectedPlan && planPrice) {
      comparePrice = parseFloat(selectedVariant?.priceV2?.amount).toFixed(2);
    }

    if (comparePrice === 0) return null;
    return comparePrice;
  };

  const getProductPrice = () => {
    let price = parseFloat(selectedVariant?.priceV2?.amount).toFixed(2);

    if (selectedPlan && planPrice) {
      price = parseFloat(planPrice.replace(currencySymbol, '')).toFixed(2);
    }

    return price;
  };

  let compareAmount = getCompareAtPrice();
  let comparePrice = compareAmount
    ? `${currencySymbol}${compareAmount}`.replace('.00', '')
    : compareAmount;
  let productPrice = `${currencySymbol}${getProductPrice()}`.replace(
    '.00',
    ''
  );

  const discountedPrice = getDiscountedPrice(settings?.automaticDiscountCollections, product, selectedVariant, currencySymbol, planPrice);

  if (discountedPrice?.productPrice && discountedPrice?.comparePrice) {
    productPrice = discountedPrice.productPrice;
    compareAmount = discountedPrice.comparePrice.replace(currencySymbol, '').replace('.00', '');
    comparePrice = discountedPrice.comparePrice;
  }

  // hide price is not us and currency conversion not found
  // if (!isUs && !isLocalized) return null;
  if (!variant) return null;

  return (
    <div
      key="product-price"
      className={`product-price font-gothamBold text-sm ${className}`}
    >
      {compareAmount && comparePriceText === '' && (
        <span className={`mr-1 text-grey-3 line-through ${compareStyles}`}>
          <div className="sr-only">Previous Price</div>
          {selectedPlan && discountedPrice?.productPrice ? productPrice : comparePrice}
        </span>
      )}

      {comparePriceText !== '' && (
        <span className={`mr-1 text-grey-3 ${compareStyles}`}>
          {comparePriceText}
        </span>
      )}
      {productPrice && (
        <span>
          <div className="sr-only text-grey-1">Current price</div>
          {selectedPlan ? planPrice : productPrice}
        </span>
      )}
    </div>
  );
}

export default ProductPrice;